// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"ec27f6ca","500":"06af42b0","636":"37cb0481","664":"1350940f","787":"8e69b55e","878":"04beecb8"}[chunkId] + ".chunk.css";
};